export default () => {
    const anchors = document.querySelectorAll('.history-nav > li > a');

    anchors?.forEach(function (element) {
        const blockID = element.getAttribute('href').substr(1);
        element.addEventListener('click', function (event) {
            event.preventDefault();	
            anchors.forEach(e => e.classList.remove('active'));
            element.classList.add("active");
            document.getElementById(blockID).scrollIntoView({
            behavior: 'smooth',
                block: 'start'
            });
        });
            
    });


    window.addEventListener("scroll", function(e) {
    const allHistory = document.querySelectorAll('.history-right section');
    allHistory.forEach(function(el, index) {
        if (el.getBoundingClientRect().top <= 50 && el.getBoundingClientRect().bottom >= 50) {
        anchors[index].classList.add("active");
        }else{
            anchors[index].classList.remove("active");
        }
    });
    });
}
